import { useAuthHttp } from '@hooks';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDocumentTitle } from 'usehooks-ts';
import { CreateInboundShipmentNoteForm } from '@forms/CreateInboundShipmentNoteForm/CreateInboundShipmentNoteForm';
import { CreateInboundShipmentNoteFormValues } from '@forms/CreateInboundShipmentNoteForm/types';
import {
  CREATE_INBOUND_SHIPMENT_NOTE_URL,
  INBOUND_SHIPMENT_TYPE,
} from '@constants';
import { toUtcZonedDateTime } from '@utils';
import dayjs from 'dayjs';

export function CreateInboundShipmentNote() {
  useDocumentTitle('FLOX - Create Inbound Shipment Note');
  const authHttp = useAuthHttp();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const pages = [
    { name: 'Home', href: '/', current: false },
    {
      name: 'Inbound Shipment Notes',
      href: '/shipments',
      current: false,
    },
    {
      name: 'Create Inbound Shipment Note',
      href: '/inbound-shipment/create',
      current: true,
    },
  ];

  const handleOnSubmit = async (data: CreateInboundShipmentNoteFormValues) => {
    setIsSubmitting(true);
    try {
      const { data: createInboundData } = await authHttp.post(
        CREATE_INBOUND_SHIPMENT_NOTE_URL,
        {
          shipmentNote: {
            shipmentNoteNumber: data.shipmentNoteNumber,
            shipmentType: 'InboundShipmentNote',
            supplierID: data.supplier?.value ?? '',
            skus: data.skuFields.map((sku) => {
              return {
                palletising: {
                  palletisingId: sku.palletising.palletisingId.value,
                },
                skuId: sku.id,
                skuQuantity: sku.skuQuantity,
              };
            }),
            comment: data.comment,
            estimatedTimeOfArrival: toUtcZonedDateTime(
              data.estimatedTimeOfArrival
            ),
            warehouseId: data.warehouse?.value ?? '',
            shipmentDate: toUtcZonedDateTime(dayjs()),
          },
        },
        { headers: { 'Content-Type': 'application/json' } }
      );

      if (createInboundData) {
        navigate('/noticeboard');
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <CreateInboundShipmentNoteForm
      onSubmit={handleOnSubmit}
      isSubmitting={isSubmitting}
      header='Create Inbound Shipment Note'
      pages={pages}
    />
  );
}
